import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { company, categories, HIDDEN_CATEGORIES, NEWS_ENABLED } from "../mock";
import Editable from "./Editable";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="text-white" style={{ background: "linear-gradient(180deg, var(--brand-800) 0%, var(--brand-900) 100%)" }}>
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-5" aria-label="Ruken Alazdehar General Trading LLC">
              <img
                src="/logo.png"
                alt="Ruken Alazdehar General Trading LLC"
                className="h-12 w-auto object-contain bg-white/95 rounded-md p-2"
              />
            </Link>
            <Editable field="footer.tagline" as="p" className="text-sm text-white/70 leading-relaxed mb-5" multiline>
              A reliable global sourcing and supply-chain partner for bulk industrial raw materials across South Asia, APAC, EMEA, and Latin America.
            </Editable>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-display font-semibold text-base mb-5 uppercase tracking-wider">Company</h4>
            <ul className="space-y-3 text-sm text-white/75">
              <li><Link to="/" className="hover:text-white inline-flex items-center gap-2 transition"><ArrowRight size={12} /> Home</Link></li>
              <li><Link to="/about-us" className="hover:text-white inline-flex items-center gap-2 transition"><ArrowRight size={12} /> About Us</Link></li>
              {NEWS_ENABLED && <li><Link to="/news" className="hover:text-white inline-flex items-center gap-2 transition"><ArrowRight size={12} /> News</Link></li>}
              <li><Link to="/contact-us" className="hover:text-white inline-flex items-center gap-2 transition"><ArrowRight size={12} /> Contact Us</Link></li>
              <li><Link to="/supplier-center" className="hover:text-white inline-flex items-center gap-2 transition"><ArrowRight size={12} /> Supplier Center</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white inline-flex items-center gap-2 transition"><ArrowRight size={12} /> Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h4 className="font-display font-semibold text-base mb-5 uppercase tracking-wider">Commodities</h4>
            <ul className="space-y-3 text-sm text-white/75">
              <li><Link to="/product-categories" className="hover:text-white inline-flex items-center gap-2 transition"><ArrowRight size={12} /> All Categories</Link></li>
              {categories.filter((c) => !HIDDEN_CATEGORIES.includes(c.slug)).map((c) => (
                <li key={c.slug}>
                  <Link to={`/products/${c.slug}`} className="hover:text-white inline-flex items-center gap-2 transition">
                    <ArrowRight size={12} /> {c.title.split(" (")[0].split(" —")[0]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-semibold text-base mb-5 uppercase tracking-wider">Get In Touch</h4>
            <ul className="space-y-4 text-sm text-white/75">
              <li className="flex gap-3">
                <MapPin size={18} className="flex-shrink-0 mt-0.5" style={{ color: "var(--brand-300)" }} />
                <span>{company.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone size={18} className="flex-shrink-0 mt-0.5" style={{ color: "var(--brand-300)" }} />
                <div className="flex flex-col gap-1">
                  <a href={`tel:${company.phone}`} className="hover:text-white">{company.phone}</a>
                  {company.landline && (
                    <a href={`tel:${company.landline.replace(/\s/g,'')}`} className="hover:text-white text-white/60 text-xs">
                      Landline: {company.landline}
                    </a>
                  )}
                </div>
              </li>
              <li className="flex gap-3">
                <Mail size={18} className="flex-shrink-0 mt-0.5" style={{ color: "var(--brand-300)" }} />
                <a href={`mailto:${company.email}`} className="hover:text-white">{company.email}</a>
              </li>
              <li className="pt-2 text-xs text-white/55">{company.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between items-center text-xs text-white/55">
          <p>© {year} Ruken Alazdehar General Trading LLC — Dubai. All Rights Reserved.</p>
          <p>We aspire to create a global channel for a solid future.</p>
        </div>
      </div>
    </footer>
  );
}
